import { useFetch } from "./useFetch";

export interface UsersByActivityRequest {
    date_1: string;
    date_2: string;
}

export interface UsersByActivityData {
    idpais: string;
    nombre_pais: string;
    cantidad_de_usuarios_rango_fechas: number;
}

export interface UsersByActivityResponse {
    success: boolean;
    message: string;
    data: UsersByActivityData[];
    errors: any[];
}

export interface UserEventActivityRequest {
    date_1: string;
    date_2: string;
    country_id: number;
}

export interface UserEventActivityData {
    id: number;
    name: string;
    email: string;
    phone: string;
    city: string;
    cantidad_de_usos: number;
    ultimo_uso: string;
}

export interface UserEventActivityResponse {
    success: boolean;
    message: string;
    data: UserEventActivityData[];
    errors: any[];
}

export const useAdminPageFetch = () => {
    const { authFetch } = useFetch();

    const getUsersByActivity = async (dateRange: UsersByActivityRequest): Promise<UsersByActivityResponse> => {
        const response = await authFetch(
            'https://iris-auth.infocasas.com.uy/api/adminpage/get-users-by-activity',
            {
                method: 'POST',
                body: JSON.stringify(dateRange),
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                },
            }
        );
        
        return response;
    };

    const getUsersEventActivity = async (request: UserEventActivityRequest): Promise<UserEventActivityResponse> => {
        const response = await authFetch(
            'https://iris-auth.infocasas.com.uy/api/adminpage/get-users-event-activity',
            {
                method: 'POST',
                body: JSON.stringify(request),
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                },
            }
        );
        
        return response;
    };

    return {
        getUsersByActivity,
        getUsersEventActivity
    };
};

